
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8778 6.30121L12.8724 2.25518C12.2816 1.91494 11.551 1.91494 10.9602 2.25518L3.9548 6.30121C3.36662 6.64146 3 7.27711 3 7.95496V16.0444C3 16.7249 3.36662 17.3579 3.9548 17.7008L10.9602 21.7442C11.2556 21.9156 11.5853 22 11.915 22C12.2447 22 12.577 21.9156 12.8698 21.7442L19.8751 17.6981C20.4633 17.3579 20.8299 16.7222 20.8299 16.0444V7.95496C20.8352 7.27447 20.4686 6.64146 19.8778 6.30121ZM19.5164 7.95496V11.7794L18.9283 11.4392L13.2206 8.14751L13.8457 7.78616L16.8288 6.06383L19.2184 7.44328C19.403 7.54878 19.5164 7.74396 19.5164 7.95496ZM11.9176 15.1054L6.54225 12.0036L11.9018 8.90976L17.2771 12.0142L11.9176 15.1054ZM4.61419 7.44328L11.6196 3.39725C11.7119 3.3445 11.8121 3.31812 11.915 3.31812C12.0178 3.31812 12.1207 3.3445 12.2104 3.39725L15.5073 5.30157L4.31878 11.7636V7.95496C4.31878 7.74396 4.4322 7.54878 4.61419 7.44328ZM4.31878 16.047V13.2855L5.22347 12.7632L10.5988 15.8677L7.0091 17.9408L4.61683 16.5587C4.4322 16.4532 4.31878 16.258 4.31878 16.047ZM19.2184 16.5587L12.213 20.6047C12.031 20.7102 11.8042 20.7102 11.6196 20.6047L8.32524 18.703L11.5088 16.8647L12.1207 16.5112L18.5933 12.7738L19.5112 13.3039V16.047C19.5164 16.258 19.403 16.4532 19.2184 16.5587Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiAlipayappFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
